"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.onNotificationArise = exports.NOTIFICATION_ARISE = exports.ON_NOTIFICATION_ARISE = void 0;
const client_1 = require("@apollo/client");
const restricted_1 = require("../query/restricted");
exports.ON_NOTIFICATION_ARISE = 'ON_NOTIFICATION_ARISE';
exports.NOTIFICATION_ARISE = (0, client_1.gql) `
  subscription OnNotificationArise($userId: Int!) {
    onNotificationArise(userId: $userId) {
      userId
      read
      type
      id
      description
      actionType
      createdAt
      fromUser {
        id
        displayName
      }
      comment {
        id
        comment
        question {
          id
          concept {
            id
            name
          }
        }
      }
    }
  }
`;
const onNotificationArise = ({ client, subscriptionData, }) => {
    const { onNotificationArise } = subscriptionData.data || {};
    if (onNotificationArise) {
        const prevData = client.readQuery({
            query: restricted_1.NOTIFICATIONS,
        });
        if (prevData) {
            client.writeQuery({
                query: restricted_1.NOTIFICATIONS,
                data: {
                    ...prevData,
                    restricted: {
                        ...prevData.restricted,
                        notifications: [
                            ...onNotificationArise,
                            ...prevData.restricted.notifications,
                        ],
                    },
                },
            });
        }
    }
};
exports.onNotificationArise = onNotificationArise;
